import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-landing-page-header',
  templateUrl: './landing-page-header.component.html',
  styleUrls: ['./landing-page-header.component.sass']
})
export class LandingPageHeaderComponent {

  constructor(private router: Router, private authService: AuthService) {
  }

  onClickLogo() {
    window.location.href = '/home';
  }

  redirectToLogin() {
    this.router.navigate(['login']);
  }

}
